import React, { useEffect, useState } from 'react';
import { Alert, AlertIcon, AlertDescription, Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import apiClient from '../../service/ApiClient.js';
import hotelSettingsService from '../../service/HotelSettingsService';

/**
 * Persistent amber banner shown on every page while this hotel's
 * communications hold is on (admin-only setting, managed from Hotel
 * Admin → Settings → Communications — not linked here, PMS staff can't
 * reach it). Reuses hotelSettingsService's cached /v1/settings call, so
 * this costs no extra endpoint.
 */
const CommunicationsHoldBanner = () => {
  const { t } = useTranslation();
  const [onHold, setOnHold] = useState(false);

  useEffect(() => {
    if (!apiClient.isAuthenticated()) return;
    let cancelled = false;
    hotelSettingsService.getSettings()
      .then((settings) => {
        if (!cancelled) setOnHold(Boolean(settings?.communicationsHold));
      })
      .catch(() => { /* banner just stays hidden if settings can't load */ });
    return () => { cancelled = true; };
  }, []);

  if (!onHold) return null;

  return (
    <Box position="sticky" top={0} zIndex={9999} width="100%">
      <Alert
        status="warning"
        bg="orange.400"
        color="black"
        borderRadius={0}
        px={4}
        py={3}
        alignItems="center"
        justifyContent="center"
      >
        <AlertIcon color="black" />
        <AlertDescription fontSize="sm" fontWeight="medium">
          {t('ui:communicationsHoldBanner.message')}
        </AlertDescription>
      </Alert>
    </Box>
  );
};

export default CommunicationsHoldBanner;
